import { validate as veeValidate } from 'vee-validate';

export default {
  validate: async (value, { options, defaultLength }) => {
    const minLengths = await Promise.all(
      options.map(({ length, phrases }) => {
        return veeValidate(value, {
          startsWith: { phrases },
        }).then(({ valid }) => valid ? length : Infinity);
      }),
    );

    const minLength = Math.min(...minLengths);

    const { valid } = await veeValidate(value, { min: { length: minLength } });

    return valid;
  },
  params: ['options'],
  message: (fieldName, { options }) => {
    let msg = `The ${fieldName.toLowerCase()} field must be at least ${Math.min(...options.map(({ length }) => length))} characters`;
    if (options.length > 1) {
      const maxOption = options.reduce((prev, curr) => {
        return prev.length > curr.length ? prev : curr;
      });
      msg += ` (or ${maxOption.length} characters for numbers starting with ${maxOption.phrases.join(', ').replace(/, ([^,]*)$/, ' and $1')})`;
    }
    msg += '.';
    return msg;
  },
};
